import PropTypes from 'prop-types';
import React from 'react';
import uniqueId from 'lodash/uniqueId';

const Switch = props => {
  const inputProps = {
    id: props.id,
    checked: props.checked,
    name: props.group,
    type: props.type,
  };

  return (
    <label htmlFor={props.id} className="c-switch">
      <input className="c-switch__input" {...inputProps} />
      <span className="c-switch__icon" />
      <span className="c-switch__label">{props.label}</span>
    </label>
  );
};

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  group: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['radio', 'checkbox']),
};

Switch.defaultProps = {
  id: uniqueId('label_'),
  checked: false,
  type: 'radio',
};

export default Switch;
